import { render, staticRenderFns } from "./OshaSubList.vue?vue&type=template&id=a2a8038e"
import script from "./OshaSubList.vue?vue&type=script&lang=js"
export * from "./OshaSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports